import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tabloOtherElementsForSnap',
    standalone: false
})
export class TabloOtherElementsForSnapPipe implements PipeTransform {
  transform(host: HTMLElement, toSkip: HTMLElement): Element[] {
    return Array.from(host.querySelectorAll('.elementContainer')).filter(
      (v) => v !== toSkip,
    );
  }
}
